<template>
  <div>
    <el-dialog
      :visible.sync="dialogShow"
      @close="close"
      :show-close="false"
      width="642px"
      custom-class="lenders"
      center>
      <div class="lendersOutcome">
        <div class="head">
          <div class="title">放款申请</div>
          <div class="closeBtn" @click="close">
            <i class="el-icon-close"></i>
          </div>
        </div>
        <div class="body" :style="{'padding':type === 1?'61px 0 107px':'26px 0 42px'}">
          <img :src="type === 1 ?require('@/assets/image/PersonalCenter/Seller/Lenders/applicationLenders.png'):require('@/assets/image/PersonalCenter/Seller/Lenders/succeedLenders.png')" alt="">
          <div class="title">{{ type === 1 ? '放款申请中' : '放款成功' }}</div>
          <div class="text">{{ type === 1 ? '预计两小时内放款' : '24小时后订单关闭, 请及时查收账号收款信息' }}</div>
          <div class="lendersInfo">
            <div class="info">
              <div class="payment-type">
                <img :src="accountInfo.account_type==='支付宝'?AlipayLogo:accountInfo.account_type==='微信'?WeChatLogo:BankLogo" alt="" class="account-head-logo" />
                {{ accountInfo.account_type == '0'  ? '' : accountInfo.account_type }}
                <span style="margin: 0 0 0 5px">{{accountInfo.account_bank_name}}</span>
              </div>
              <div class="payment-acc">
                <span>{{accountInfo.account_user_name}}</span>
                {{accountInfo.account}}
              </div>
            </div>
            <img v-if="type === 3" src="@/assets/image/PersonalCenter/Seller/Lenders/succeed.png" alt="">
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {apiUserAccountLendAcc} from "@/request/API";
import AlipayLogo from "@/assets/image/PersonalCenter/MyAccount/ali.png";
import WeChatLogo from "@/assets/image/PersonalCenter/MyAccount/wechat.png";
import BankLogo from "@/assets/image/PersonalCenter/MyAccount/bank.png";
export default {
  name: "lendersOutcome",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    close: {
      type: Function,
      default: null
    },
    type:{
      type: Number,
      default: 1
    },
    game_id:{
      type: Number,
      default: 1
    },
    product_id:{
      type: Number,
      default: 1
    },
  },
  components:{},
  data(){
    return {
      dialogShow:this.show,
      accountInfo:{},
      AlipayLogo,
      WeChatLogo,
      BankLogo
    }
  },
  methods:{
    getAccountInfo(){
      apiUserAccountLendAcc({
        game_id:this.game_id,
        product_id:this.product_id,
      }).then(res=>{
        this.accountInfo = res.data
      })
    }

  },
  watch:{
    show(val) {
      if (val) {
        this.getAccountInfo()
      }
      this.dialogShow = val
    },
  },
  created() {

  },
  mounted() {
  }
}
</script>

<style scoped lang="less">
/deep/ .lenders {
  .el-dialog__header, .el-dialog__body {
    padding: 0 !important;
  }

  .el-icon-close {
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 800;
  }
}

.lendersOutcome {
  .head {
    height: 66px;
    line-height: 66px;
    text-align: center;
    background: var(--bg-dark, #1A1D24);
    border-radius: 4px 4px 0 0;
    position: relative;

    .title {
      font-size: 22px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
    }

    .closeBtn {
      font-size: 30px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      position: absolute;
      right: 23px;
      top: 0;
      cursor: pointer;
    }
  }
  .body {
    width: 642px;
    display: flex;
    flex-direction: column;
    align-items: center;
    img{
      width: 120px;
      height: 95px;
    }
    .title{
      font-size: 22px;
      font-family: PingFang SC-Semibold, PingFang SC;
      font-weight: 600;
      color: #000000;
      margin: 22px 0 5px;
    }
    .text{
      font-size: 16px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
    }
    .lendersInfo{
      min-width: 284px;
      margin: 40px 0 0;
      padding: 15px 37px 15px 30px;
      box-shadow: 0px 1px 6px 0px rgba(0,0,0,0.15);
      display: flex;
      align-items: center;
      justify-content: space-between;
      .info{
        .payment-type{
          display: flex;
          align-items: center;
          font-size: 14px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #000000;
          margin: 0 0 5px;
          i{
            margin: 0 5px 0 0;
          }
        }
        .payment-acc{
          font-size: 14px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #777777;
          span{
            margin: 0 10px 0 0;
          }
        }
      }
      img{
        width: 16px;
        height: 16px;
        margin-right: 8px;
      }
    }
  }
}

</style>
